import { render, staticRenderFns } from "./HomeAtendente.vue?vue&type=template&id=6c03db5d&scoped=true"
import script from "./HomeAtendente.vue?vue&type=script&lang=js"
export * from "./HomeAtendente.vue?vue&type=script&lang=js"
import style0 from "./HomeAtendente.vue?vue&type=style&index=0&id=6c03db5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c03db5d",
  null
  
)

export default component.exports